import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Modal } from "react-responsive-modal";
import styled from "styled-components";
import NumberPad from "../../components/NumberPad";
import Toggle from "../../components/Toggle";
import { langState, langText } from "../../recoil/lang";
import { useToast } from "../../controller/ToastController";
import { useRecoilState, useRecoilValue } from "recoil";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  doPayment: any;
  setNumber: (number: string) => void;
  setEmail: (email: string) => void;
  mainTitle: string;
  subTitle?: string;
  setPaymentReady?:any;
};

const CustomerInfoModal = ({
  isVisible,
  setVisible,
  doPayment,
  setNumber,
  setEmail,
  mainTitle,
  subTitle,
  setPaymentReady,
}: Props) => {
  const lang = useRecoilValue<number>(langState);
  const [numberTemp, setNumberTemp] = useState<string>("");
  const [emailTemp, setEmailTemp] = useState<string>("");

  const [toggleOn, setToggleOn] = useState(true);

  const showToast = useToast();
  const onClose = () => {
    setVisible(false);
  };

  const changeNumber = (e: any) => {
    if (e.length <= 8) {
      setNumberTemp(e);
    }
  };

  const changeEmail = (e: any) => {
    setEmailTemp(e.target.value);
  };

  const formatPhoneNumberWithColor = (number: string) => {
    const paddedNumber = number.padEnd(8, "0");

    const firstPart = paddedNumber.slice(0, 4);
    const secondPart = paddedNumber.slice(4, 8);

    const renderColoredPart = (part: string, enteredCount: number) => {
      return part.split("").map((digit, index) => {
        const isEntered = index < enteredCount;
        return (
          <span key={index} style={{ color: isEntered ? "#fff" : "#737373" }}>
            {digit}
          </span>
        );
      });
    };

    const enteredDigitsCount = number.length;
    const hyphenColor = enteredDigitsCount >= 4 ? "#fff" : "#737373";

    return (
      <>
        <span>010-</span>
        {renderColoredPart(firstPart, Math.min(enteredDigitsCount, 4))}
        <span style={{ color: hyphenColor }}>-</span>
        {renderColoredPart(secondPart, Math.max(0, enteredDigitsCount - 4))}
      </>
    );
  };

  const saveSMSInfo = () => {
    if (toggleOn) setNumber("010" + numberTemp);
    else setEmail(emailTemp);
  };

  const goPayment = () => {
    console.log("number", numberTemp, "email", emailTemp);
    if (
      (toggleOn && numberTemp.length === 8) ||
      (!toggleOn && emailTemp.length > 5)
    ) {
      saveSMSInfo();
      setPaymentReady(true);
      doPayment();
    } else {
      showToast("정보를 입력해주세요.", "error");
    }
  };

  useEffect(() => {
    setToggleOn(true);
    if (!isVisible) {
      setNumberTemp("");
      setEmailTemp("");
    }
  }, [isVisible]);
  useEffect(() => {
    setNumberTemp("");
    setEmailTemp("");
  }, [toggleOn]);

  return (
    <Modal
      open={isVisible}
      onClose={onClose}
      center
      closeOnOverlayClick={false}
      classNames={{
        modal: "customerInfoModal",
      }}
      showCloseIcon={true}
      animationDuration={150}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="닫기 아이콘"
        />
      }
    >
      <Style>
        <div className="modalWrapper">
          <div className="title">
            <h2>{mainTitle}</h2>
            <p>{subTitle}</p>
          </div>
          <div className="customerTypeWrap">
            <Toggle
              toggleOn={toggleOn}
              setToggleOn={setToggleOn}
              toggle1={
                <>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_kakao${
                      toggleOn ? "_active" : ""
                    }.svg`}
                    alt="카카오톡 아이콘"
                  />
                  {langText.customer_info_modal_kakao[lang]}
                </>
              }
              toggle2={
                <>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_email${
                      !toggleOn ? "_active" : ""
                    }.svg`}
                    alt="카카오톡 아이콘"
                  />
                  E-MAIL
                </>
              }
            />
          </div>
          <div className="customerInfoWrap">
            {toggleOn ? (
              <div className="phoneWrap">
                <h1>{formatPhoneNumberWithColor(numberTemp)}</h1>
                <div>
                  <NumberPad number={numberTemp} setNumber={changeNumber} />
                </div>
              </div>
            ) : (
              <div className="emailWrap">
                <input
                  value={emailTemp}
                  onChange={(e) => changeEmail(e)}
                  type="text"
                  placeholder="Please enter your e-mail"
                />
              </div>
            )}
          </div>

          <div className="modalFooter">
            <button onClick={goPayment}>{langText.button_confirm[lang]}</button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CustomerInfoModal;

const Style = styled.div`
  h1,
  h2,
  h3,
  h4,
  p {
    padding: 0;
    margin: 0;
  }

  /* modalWrapper */
  .modalWrapper {
    position: relative;
    padding: 60px 0 40px 0;
    height: 100%;
    background: #343434;
    overflow: hidden;
  }
  .title {
    padding: 0 3vw;
    h2 {
      font-size: 32px;
      font-weight: 500;
      color: #fff;
      text-align: center;
      line-height: 50px;
      white-space: pre-line;
    }
    p {
      margin-top: 30px;
      font-size: 20px;
      font-weight: 500;
      color: #ff4a4a;
      line-height: 28px;
      text-align: center;
      white-space: pre-line;
    }
  }

  /* customerTypeWrap */
  .customerTypeWrap {
    width: 90%;
    margin: 0 auto;
    margin-top: 37px;
  }
  /* customerInfoWrap */
  .customerInfoWrap {
    text-align: center;

    h1 {
      margin: 34px 0;
    }
    span {
      font-size: 40px;
      font-weight: 600;
    }
    .emailWrap {
      margin: 20px 0 10px 0;

      input {
        width: 90%;
        padding: 10px;
        text-align: center;
        background: none;
        border: 2px solid #cecece;
        font-size: 32px;
        font-weight: 600;
        color: #fff;
        border-radius: 10px;
      }
      input::placeholder {
        color: #737373;
      }
    }
  }

  /* numberPadWrap */
  .numberPadWrap {
    padding: 12px 0;
    background: #232323;
  }

  /* modalFooter */
  .modalFooter {
    padding: 35px 40px 0 40px;
    button {
      width: 100%;
      padding: 17px 0;
      background: #4dd2ae;
      border-radius: 10px;
      font-size: 24px;
      font-weight: 600;
      color: #fff;
    }
  }
`;
